'use client'

import { useState } from 'react'
import type { Values } from 'types'
import { useSylveraQuery } from '@sylveraio/react-utils'
import type { ApolloClient } from '@apollo/client'
import { type Projects, GET_PROJECTS } from '@sylveraio/react-utils'

export function useProjectsFromSupplyRequest(
  client: ApolloClient<any>,
  projectIdList: Array<string>,
) {
  const [projectList, setProjectList] = useState<Values>([])

  useSylveraQuery<Projects>(GET_PROJECTS, client, {
    variables: {
      first: projectIdList.length,
      condition: {
        publicId: {
          in: projectIdList,
        },
      },
    },
    onCompleted: (data: Projects) => {
      if (!data) {
        setProjectList([])
        return
      }

      const projectValues =
        data.projects?.nodes?.map(({ publicId, name, projectRegistry }) => {
          return {
            text: `${projectRegistry.registry.name} ${
              projectRegistry.registryProjectId
            } ${name ? `(${name})` : ''}`,
            value: publicId,
          }
        }) || []

      setProjectList(projectValues)
    },
  })

  return {
    projectList,
  }
}
